export default {
    'name': 'booth',
    'getComponent': () => import('./BoothCanvas.vue'),
    'tabIndex': 0,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/booth',
    'selfHandelPadding': true
};
